/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateTuitionDiscountRequest,
  GetTuitionDiscountResponse,
  Result,
  UpdateTuitionDiscountRequest,
} from '../models/index';
import {
    CreateTuitionDiscountRequestFromJSON,
    CreateTuitionDiscountRequestToJSON,
    GetTuitionDiscountResponseFromJSON,
    GetTuitionDiscountResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    UpdateTuitionDiscountRequestFromJSON,
    UpdateTuitionDiscountRequestToJSON,
} from '../models/index';

export interface ApiDiscountsDiscountIdDeleteRequest {
    discountId: string;
    xTenantID?: number;
}

export interface ApiDiscountsDiscountIdPutRequest {
    discountId: string;
    updateTuitionDiscountRequest: UpdateTuitionDiscountRequest;
    xTenantID?: number;
}

export interface ApiDiscountsGetRequest {
    xTenantID?: number;
}

export interface ApiDiscountsPostRequest {
    createTuitionDiscountRequest: CreateTuitionDiscountRequest;
    xTenantID?: number;
}

export interface GetDiscountByIdRequest {
    id: string;
    xTenantID?: number;
}

/**
 * 
 */
export class DiscountsApi extends runtime.BaseAPI {

    /**
     * Deletes a tuition discount by its unique identifier.
     * Deletes a tuition discount by its unique identifier.
     */
    async apiDiscountsDiscountIdDeleteRaw(requestParameters: ApiDiscountsDiscountIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['discountId'] == null) {
            throw new runtime.RequiredError(
                'discountId',
                'Required parameter "discountId" was null or undefined when calling apiDiscountsDiscountIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/discounts/{discountId}`;
        urlPath = urlPath.replace(`{${"discountId"}}`, encodeURIComponent(String(requestParameters['discountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a tuition discount by its unique identifier.
     * Deletes a tuition discount by its unique identifier.
     */
    async apiDiscountsDiscountIdDelete(requestParameters: ApiDiscountsDiscountIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDiscountsDiscountIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Updates an existing tuition discount with the specified parameters.
     * Update a tuition discount
     */
    async apiDiscountsDiscountIdPutRaw(requestParameters: ApiDiscountsDiscountIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['discountId'] == null) {
            throw new runtime.RequiredError(
                'discountId',
                'Required parameter "discountId" was null or undefined when calling apiDiscountsDiscountIdPut().'
            );
        }

        if (requestParameters['updateTuitionDiscountRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTuitionDiscountRequest',
                'Required parameter "updateTuitionDiscountRequest" was null or undefined when calling apiDiscountsDiscountIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/discounts/{discountId}`;
        urlPath = urlPath.replace(`{${"discountId"}}`, encodeURIComponent(String(requestParameters['discountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTuitionDiscountRequestToJSON(requestParameters['updateTuitionDiscountRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates an existing tuition discount with the specified parameters.
     * Update a tuition discount
     */
    async apiDiscountsDiscountIdPut(requestParameters: ApiDiscountsDiscountIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDiscountsDiscountIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get all tuition discounts
     * Get all discounts
     */
    async apiDiscountsGetRaw(requestParameters: ApiDiscountsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTuitionDiscountResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/discounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTuitionDiscountResponseFromJSON));
    }

    /**
     * Get all tuition discounts
     * Get all discounts
     */
    async apiDiscountsGet(requestParameters: ApiDiscountsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTuitionDiscountResponse>> {
        const response = await this.apiDiscountsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new tuition discount with the specified parameters.
     * Create a tuition discount
     */
    async apiDiscountsPostRaw(requestParameters: ApiDiscountsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createTuitionDiscountRequest'] == null) {
            throw new runtime.RequiredError(
                'createTuitionDiscountRequest',
                'Required parameter "createTuitionDiscountRequest" was null or undefined when calling apiDiscountsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/discounts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTuitionDiscountRequestToJSON(requestParameters['createTuitionDiscountRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new tuition discount with the specified parameters.
     * Create a tuition discount
     */
    async apiDiscountsPost(requestParameters: ApiDiscountsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiDiscountsPostRaw(requestParameters, initOverrides);
    }

    /**
     * Get a tuition discount by its unique identifier
     * Get discount by Id
     */
    async getDiscountByIdRaw(requestParameters: GetDiscountByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTuitionDiscountResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getDiscountById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/discounts/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTuitionDiscountResponseFromJSON(jsonValue));
    }

    /**
     * Get a tuition discount by its unique identifier
     * Get discount by Id
     */
    async getDiscountById(requestParameters: GetDiscountByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTuitionDiscountResponse> {
        const response = await this.getDiscountByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
